// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47d11382","453":"bfa26897"}[chunkId] + ".chunk.js";
};